export default __webpack_public_path__ + "static/media/cn.acb9cced.svg";